var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 66,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M32.5 27.902v9.876h13.723c-.602 3.176-2.41 5.865-5.123 7.673l8.276 6.421c4.822-4.45 7.604-10.988 7.604-18.754 0-1.808-.163-3.547-.464-5.216H32.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m18.209 37.392-1.867 1.429-6.607 5.146C13.931 52.29 22.531 58.04 32.5 58.04c6.885 0 12.658-2.272 16.877-6.167L41.1 45.451c-2.272 1.53-5.17 2.457-8.601 2.457-6.63 0-12.263-4.474-14.28-10.501l-.01-.015Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M9.735 21.11A25.185 25.185 0 0 0 7 32.538c0 4.127.997 7.998 2.735 11.43 0 .022 8.485-6.585 8.485-6.585a15.28 15.28 0 0 1-.811-4.845c0-1.692.3-3.315.81-4.845L9.736 21.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M32.5 17.192c3.755 0 7.093 1.299 9.76 3.802l7.301-7.302C45.134 9.566 39.385 7.039 32.5 7.039c-9.968 0-18.568 5.726-22.764 14.071l8.485 6.583c2.017-6.027 7.65-10.5 14.28-10.5Z"
  })));
};
export default SvgGoogle;